class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.updateFreeShippingProgress();
    this.open();
  }

  updateFreeShippingProgress() {
    const shippingMessage = document.getElementById('bcs-cart-notification-shipping');
    if (!shippingMessage) return;

    fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        if (!cart.item_count) {
          shippingMessage.hidden = true;
          return;
        }

        const threshold = Number(shippingMessage.dataset.threshold || 5900);
        const total = Number(cart.total_price || 0);
        const remaining = Math.max(threshold - total, 0);
        const progress = Math.min((total / threshold) * 100, 100);
        const bar = shippingMessage.querySelector('.bcs-cart-notification-shipping__bar');
        const message = shippingMessage.querySelector('.bcs-cart-notification-shipping__text');

        if (bar) bar.style.width = `${progress}%`;
        if (message) {
          if (remaining > 0) {
            const locale = document.documentElement.lang || 'fr-FR';
            const currency = cart.currency || 'EUR';
            const amount = new Intl.NumberFormat(locale, {
              style: 'currency',
              currency: currency,
            }).format(remaining / 100);

            message.textContent = shippingMessage.dataset.remainingMessage.replace('[amount]', amount);
          } else {
            message.textContent = shippingMessage.dataset.unlockedMessage;
          }
        }

        shippingMessage.hidden = false;
      })
      .catch(() => {
        shippingMessage.hidden = true;
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
